import React from 'react';
import './Logo.css';

const Logo = ({ collapsed = false, isMobile = false }) => {
  const isCompact = collapsed || isMobile;

  return (
    <div className={`app-logo ${isCompact ? 'compact' : ''}`}>
      {isCompact ? (
        // Collapsed: Show only shirt icon (favicon)
        <img 
          src="/favicon.svg" 
          alt="Jam & Sugar" 
          className="logo-icon-compact" 
        />
      ) : (
        // Expanded: Show full logo with text and shirt
        <img 
          src="/logo-full.svg" 
          alt="Jam & Sugar Admin Console" 
          className="logo-image-full" 
        />
      )}
    </div>
  );
};

export default Logo;

